export default __webpack_public_path__ + "static/poster2-0a759b463df7c128e0d5e04deea0e746.webp";